<template>
    <DCard
        padding
    >
        <div class="mb-5">
            <h4>
                {{ __('tools.emails.footer_links.title') }}
            </h4>
        </div>
        <DTable
            :items="links"
            :fields="fields"
        >
            <template #brand="{item}">
                <td>
                    {{ formatName(item) ?? + ' ' . item.language.text }}
                </td>
            </template>
            <template #action="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            mini
                            icon="pencil"
                            @click="editFlavour(item)"
                        />
                        <DButton
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="defaultLanguages.includes(item.language.value)"
                            @click="deleteFlavour(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('tools.emails.footer_links.add')"
                @click="addFlavour"
            />
        </DFabs>
        <DModal
            v-if="showDeleteConfirmationModal"
            v-model:show="showDeleteConfirmationModal"
            :title="__('tools.emails.footer_links.deleteLinksModal.title')"
            :message="__('tools.emails.footer_links.deleteLinksModal.message')"
            is-confirm
            is-error
            @close="showDeleteConfirmationModal = false"
            @confirm="modalAcceptCallback"
        />
    </DCard>
</template>

<script>

import { __ } from '~@/Composables/translation'

export default {
    name: 'Index',
    props: {
        links: {
            type: Array,
            default: () => { return [] }
        },
        existingBrandFlavours: {
            type: Array,
            default: () => { return [] }
        },
        defaultLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'brand', label: this.__('tools.emails.footer_links.language') },
                { key: 'action', label: '' }
            ],
            showDeleteConfirmationModal: false,
            modalAcceptCallback: null
        }
    },
    computed: {
        countDefaultLanguages () {
            return this.existingBrandFlavours.filter(item => item.id === null).length
        }
    },
    methods: {
        addFlavour () {
            this.$inertia.get(this.$route('tools.emails.footer-links-create'))
        },
        editFlavour (item) {
            const params = {
                language_code: item.language.value
            }

            this.$inertia.get(this.$route('tools.emails.footer-links-edit', params))
        },
        deleteFlavour (item) {
            this.showDeleteConfirmationModal = true
            this.modalAcceptCallback = () => {
                this.$inertia.delete(this.$route('tools.emails.footer-links-delete', {
                    language_code: item.language.value
                }))
                this.showDeleteBrandConfirmationModal = false
            }
        },
        formatName (item) {
            if (this.defaultLanguages.includes(item.language.value)) {
                return __('tools.emails.editor.default') + ' ' + item.language.text
            }

            return item.language.text
        }
    }
}
</script>
